const Builder = require('./BuilderBase');
const Button = require('./Button');
const ShortTextView = require('./dataViews/ShortTextView');

module.exports = class SimpleDialog extends Builder {
    constructor(title, properties) {
        super('dialog_SimpleDialog', title, properties);
    }

    button(title, properties) {
        let actionElement = new Button(title, properties);
        this.addChildBlock(actionElement);
        return this;
    }

    shortTextView(title, properties) {
        let shortTextView = new ShortTextView(title, properties);
        this.addChildBlock(shortTextView);
        return shortTextView;
    }
};
